<template>
<div>
  <HeaderRanking :currentCountry="currentCountry || currentZone"/>
  <v-row
    no-gutters
    justify="start"
    class="worldwideMask" >
    <div class="wrapperWidthBottom px-md-0 px-4" id="rankingTop">
      <h1 class="primary--text text-h5 text-md-h4 font-weight-bold ml-md-0 mt-7">
				<template v-if="currentTop !== null">
					<div v-html="textTitle"></div>
				</template>
				<template v-else>
					<translate :key="currentTop" class="mr-1">BEST GOLF COURSES IN</translate>
          <span v-html="currentRankingName"></span>
				</template>
			</h1>
      <v-row class="pa-md-0 pb-md-5">
        <v-col cols="12" :md="8" :sm="7" class="d-flex flex-column">
          <PaginationRanking
            @loadTop="loadTop"
            :currentTop="parseInt($route.params.top)"
            :currentCountry="currentCountry"
            :currentZone="currentZone"
            v-if="courses.length > 0"
          />
          <div>
            <CardRanking
              v-for="(item, idx) in courses"
              :key="idx"
              :data="item"
              :currentTop="($route.params && $route.params.top) ? $route.params.top : 10"
              :isFlag="true"
              :idx="idx+1"
            />
          </div>
          <InfiniteScrollBottom
            v-if="shouldLoadMore"
            @loadMore="loadMore"
          />
          <PaginationRanking
            @loadTop="scrollToView"
            :currentTop="parseInt($route.params.top)"
            :currentCountry="currentCountry"
            :currentZone="currentZone"
            v-if="courses.length > 0"
          />
        </v-col>
        <v-col cols="12" :md="4" :sm="5" :class="isMobile ? 'd-none' : 'mt-7'">
          <LatestReviewCard />
          <LatestVlogCard />
        </v-col>
      </v-row>
    </div>
  </v-row>
</div>
</template>
<script>
import CardRanking from '@/components/Ranking/CardRanking';
import HeaderRanking from '@/components/Ranking/HeaderRanking.vue';
import InfiniteScrollBottom from '@/components/Ranking/InfiniteScrollBottom.vue';
import PaginationRanking from '@/components/Ranking/PaginationRanking.vue';
import LatestReviewCard from "@/components/Card/LatestReviewCard";
import LatestVlogCard from "@/components/Card/LatestVlogCard";
export default {
  name: 'Ranking',
  metaInfo() {
    return {
      title: this.metaTitle,
      titleTemplate: null,
      meta: [{
        name: 'description',
        content: this.metaDescription,
        vmid: 'description'
      }]
    }
  },
  components: {
    CardRanking,
    HeaderRanking,
    InfiniteScrollBottom,
    PaginationRanking,
    LatestReviewCard,
    LatestVlogCard
  },
  data() {
    return {
      currentCountry: null,
      currentZone: null,
      courses: [],
      currentPage: 1,
      totalPages: 0,
      counter: 0,
      isMobile: false
    }
  },
  computed: {
    prerendering() {
      return this.$store.getters.prerendering;
    },
    textTitle() {
      return this.$gettextInterpolate(this.$gettext('BEST GOLF COURSES RANKING TOP %{top} %{name}'), {top: this.currentTop || '' , name: this.currentRankingName})
    },
    currentTop() {
      const counter = this.counter
      return (this.$route.params && this.$route.params.top)
                  ? parseInt(this.$route.params.top) : null
    },
    currentRankingName() {
      if(this.$route.params.country || this.$route.params.zone) {
        if(this.currentCountry) {
          return this.currentCountry.name.toUpperCase()
        } else if (this.currentZone) {
          return this.currentZone.name.toUpperCase()
        } else {
          const name = this.$route.params.country || this.$route.params.zone
          return name.replace(/-/g,' ').toUpperCase()
        }
      } else {
        return this.$gettext('WORLDWIDE')
      }
    },
    metaTitle() {
      const binder = {
        rankNumber: this.currentTop === null ? '' : this.currentTop,
        rankName: this.currentRankingName
      }
      const translated = this.$gettext('Golf course ranking top %{rankNumber} %{rankName}, best golf courses');
      return this.$gettextInterpolate(translated, binder)
    },
    metaDescription() {
      const binder = {
        rankNumber: this.currentTop === null ? '' : this.currentTop,
        rankName: this.currentRankingName
      }
      const translated = this.$gettext('Discover the Golf course ranking top %{rankNumber} worldwide, where are the top %{rankNumber} best golf courses %{rankName}, read every reviews of the top %{rankNumber} golf courses %{rankName}. Ranked by BGC');
      return this.$gettextInterpolate(translated, binder)
    },
    shouldLoadMore() {
      const top = this.$route.params.top
      if(this.courses.length <= 0)
        return false
      if(parseInt(top) <= 50)
        return false
      if(this.courses.length >= 150)
        return false
      if(this.currentPage >= 62)
        return false
      if(this.currentPage == this.totalPages)
        return false
      if(this.currentPage == 10 && this.currentTop == 100)
        return false
      if(this.currentPage == 20 && this.currentTop == 200)
        return false
      if(this.currentPage == 30 && this.currentTop == 300)
        return false
      if(this.currentPage == 40 && this.currentTop == 400)
        return false
      if(this.currentPage == 50 && this.currentTop == 500)
        return false
      if(this.currentPage == 100 && this.currentTop == 1000)
        return false
      return true
    },
  },
  async mounted() {
    this.onResize();
    window.addEventListener('resize', this.onResize, { passive: true })
    this.currentPage = this.getPageFromTopParam(this.$route.params.top)
    const data = {page: this.currentPage}
    if(this.$route.params.country) {
      data.country = await this.$store.dispatch(
                        'getCountryBySlug',
                        this.$route.params.country
                      )
      this.currentCountry = data.country
      this.currentZone = null
    } else if(this.$route.params.zone) {
      data.zone = await this.$store.dispatch(
                        'getZoneBySlug',
                        this.$route.params.zone
                      )
      this.currentZone = data.zone
      this.currentCountry = null
    } else {
      this.currentCountry = null
      this.currentZone = null
    }
    const response = await this.$store.dispatch('getListCourse', data)
    this.courses = response.list
    this.totalPages = response.totalPages
    this.loadMorePrerender()
  },
  beforeDestroy () {
    if (typeof window === 'undefined') return;
    window.removeEventListener('resize', this.onResize, { passive: true })
  },
  methods: {
    onResize () {
      this.isMobile = window.innerWidth < 600;
    },
    getPageFromTopParam(top) {
      if(!top) return 1
      const map = {
        10: 1,
        20: 2,
        30: 3,
        40: 4,
        50: 5,
        100: 6,
        200: 11,
        300: 21,
        400: 31,
        500: 41,
        1000: 51,
      }
      return map[top]
    },
    async loadTop(payload) {
      if(!window.cordova) {
        let elementParent = payload.$event.target.parentElement
        if(elementParent.tagName.toLowerCase() !== 'a') {
          elementParent = elementParent.parentElement
        }
        history.pushState(
          {},
          null,
          elementParent.href
        )
      }
      const nextTop = payload.link.params ? payload.link.params.top : null
      this.$route.params.top = nextTop
      this.currentPage = this.getPageFromTopParam(nextTop)
      const data = {page: this.currentPage}
      console.log('load top: ', data);
      if(this.$route.params.country) {
        data.country = this.currentCountry
      }
      if(this.$route.params.zone) {
        data.zone = this.currentZone
      }
      const response = await this.$store.dispatch('getListCourse', data)
      this.courses = response.list
      this.counter++
    },
    scrollToView(payload) {
      this.loadTop(payload)
      const elmnt = document.getElementById("rankingTop");
      elmnt.scrollIntoView();
    },
    async loadMore() {
      this.currentPage ++;
      const data = {page: this.currentPage}
      if(this.$route.params.country) {
        data.country = this.currentCountry
      }
      if(this.$route.params.zone) {
        data.zone = this.currentZone
      }
      const response = await this.$store.dispatch('getListCourse', data)
      this.courses = this.courses.concat(response.list)
    },
    async loadMorePrerender() {
      if(!this.prerendering) return
      this.$store.state.toggle.isRankingFetch = false;
      if(this.shouldLoadMore){
        await this.loadMore()
        return await this.loadMorePrerender()
      } else {
        this.$store.state.toggle.isRankingFetch = true;
      }
    }
  }
}
</script>